import { Component, forwardRef, EventEmitter, OnInit, Input, Output } from '@angular/core';
import { EmailValidator, FormBuilder, FormGroup, Validators, FormArray } from '@angular/forms';
import {Message, OverlayPanel, SelectItem} from 'primeng/primeng';

import * as ent from '../../entities/index'
import * as serv from '../../services/index'

//constants
import { Constants }         from '../../constants/Constants';

@Component({
  selector: 'my-messagehandler',
  templateUrl: './MessageHandler.component.html'
})
export class MessageHandlerComponent implements OnInit {

    public msgs: Message[] = [];
    

    constructor() 
    { 
    }


    ngOnInit(): void {
    }
    
    handleResponse(response: ent.Response){
       
        
        if (response.Success){
            for (var vm of response.ValidationMessages){
                var msg: Message = {severity:'success', summary:'Success', detail:vm.MessageText}
                this.msgs = [...this.msgs, msg];
                setTimeout(() => {
                    this.msgs.splice(this.msgs.indexOf(msg), 1);
                }, 7000);
                
            }
        }
        else{
            for (var vm of response.ValidationMessages){
                var msg: Message = {severity:'error', summary:'Error', detail:vm.MessageText}

                this.msgs = [...this.msgs, msg];
                setTimeout(() => {
                    this.msgs.splice(this.msgs.indexOf(msg), 1);
                }, 7000);
            }
        }
    }

    

}